//loading
export const HIDE_LOADING = 'HIDE_LOADING';
export const SHOW_LOADING = 'SHOW_LOADING';

// 推荐码
export const SET_RECOMMEND = 'SET_RECOMMEND';

// 设置用户信息
export const SET_USERINFO = 'SET_USERINFO';
export const SET_TOKEN_SCOKET = 'SET_TOKEN_SCOKET';
export const SET_CHANNEL = 'SET_CHANNEL';
export const SET_PID = 'SET_PID';

export const SET_CODE = 'SET_CODE';
export const SET_APP_FLAG = 'SET_APP_FLAG';
export const SET_MJB = 'SET_MJB';


export const SET_LOGIN_OBJ = 'SET_LOGIN_OBJ';


export const SET_USERLIST = 'SET_USERLIST'

// 弹窗的显示隐藏
export const SET_WX_ALERT = 'SET_WX_ALERT';



export const TIME_OBJ = 'TIME_OBJ'


//登录退出
export const LOGIN = 'LOGIN';
export const LOGINOUT = 'LOGINOUT';



// WEBPACK FOOTER //
// ./src/store/types.js